// extracted by mini-css-extract-plugin
export default {"ecom-header":"FSLJq5","ecomHeader":"FSLJq5"};